
import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Common_Images_Transport from '../common_imges_transport/Common_Images_Transport';
import { CartProvider } from '../../../context/Cart_Context';
import Mobile_Toggle from './Mobile_Toggle';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCartList } from '../../../redux/actions/cartActions';
import { fetchWishlist } from '../../../redux/actions/wishlistActions';
import { fetchMasterData } from '../../../redux/actions/masterdataActions';

import { IMG_BASE_URL } from '../../../config/Config';
import { Add_To_Fav, Category_List, Sub_Category_List } from '../../../api/category_product/Category_Product';

import { User_Authentication } from '../../../user_authentication/User_Authentication';
import { toast } from 'react-toastify'

import Cart_Sidebar from '../cart_sidebar/Cart_Sidebar';
import { Search } from "lucide-react";
import { MdDelete } from 'react-icons/md';
import { fetchSettingData } from '../../../redux/actions/settingAction';
import { fetchHomeData } from '../../../redux/actions/homedataAction';
import { fetchGlobalSearchingData } from '../../../redux/actions/globalSearchingDataActions';

const Header = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [is_language_Open, setIs_Language_Open] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState("English");
    const { homeData, isLoading } = useSelector(
        (state) => state?.homedata || []
    );
    const { globalSearchData } = useSelector(
        (state) => state?.globalSearchData || []
    );
    const { cartlist, isloading, error } = useSelector((state) => state?.cartlist);
    const [cart_list, set_Cart_List] = useState(cartlist || []);
    const { wishlist = [] } = useSelector((state) => state.wishlist || {});
    const [is_loading, set_Is_Loading] = useState(isLoading || false)

    const { horoscopePages } = useSelector(
        (state) => state?.masterdata || []
    );
    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const [showInput, setShowInput] = useState(false);
    const [query, setQuery] = useState("");
    const [filteredSuggestions, setFilteredSuggestions] = useState(homeData || {});
    const [isCartOpen, setIsCartOpen] = useState(false);
    // const [home_data, set_Home_Data] = useState([]);
    const inputRef = useRef(null);
    const [fullData, setFullData] = useState(homeData || {});
    const [categorylist, setCategoryList] = useState([])
    const [gemstone_subcategorylist, setGemstoneSubCategoryList] = useState([])
    const [jewellery_subcategorylist, setJewellerySubCategoryList] = useState([])
    const [activeIndex, setActiveIndex] = useState(-1);
    const [isOpen, setIsOpen] = useState(false);
    const [searchIndex, setSearchIndex] = useState([]);

    const searchRef = useRef(null);

    // const [showGemstoneMenu, setShowGemstoneMenu] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const more_Categories = categorylist?.filter((more_cate) => { return more_cate?.more_type == "more" })

    const SEARCH_SOURCES = {
        product: [
            'best_selling_product',
            'popular_product',
            'gemstone_product',
            'shop_by_collection'
        ],
        pandit: ['live_pandit'],
        astrologer: ['live_astro'],
        category: ['category'],
        blogs: ['blog']
    };
    // const flatResults = Object.values(filteredSuggestions || {}).flat();


    useEffect(() => {
        dispatch(fetchHomeData());
        dispatch(fetchGlobalSearchingData());
    }, [dispatch]);

    const handleToggle = () => {
        setShowInput(!showInput);
        setTimeout(() => inputRef.current?.focus(), 0);
    };



    console.log("globalSearchData", globalSearchData);
    const buildSearchIndex = (fullData) => {
        const map = new Map();

        Object.entries(SEARCH_SOURCES).forEach(([type, keys]) => {
            keys.forEach((key) => {
                const items = fullData[key];
                if (Array.isArray(items)) {
                    items.forEach(item => {
                        const uniqueKey =
                            type === "product"
                                ? item.id || item.slug
                                : item.username;   // pandit / astrologer

                        if (!map.has(`${type}-${uniqueKey}`)) {
                            map.set(`${type}-${uniqueKey}`, {
                                ...item,
                                type,
                                _searchText: `${item.name || item.username || item.title || ""}`.toLowerCase()
                            });
                        }
                    });
                }
            });
        });

        return Array.from(map.values());
    };


    // useEffect(() => {
    //     if (!query.trim()) {
    //         setFilteredSuggestions([]);
    //         return;
    //     }

    //     const value = query.trim();

    //     let allProducts = [];
    //     PRODUCT_KEYS.forEach((key) => {
    //         const items = fullData[key];
    //         if (Array.isArray(items)) {
    //             const matchedItems = items.filter((item) => {
    //                 return (
    //                     item?.name &&
    //                     item.name.toLowerCase().includes(value.trim().toLowerCase())
    //                 );
    //             });

    //             allProducts = allProducts.concat(matchedItems);
    //         }
    //     });

    //     // Step 2: Deduplicate products by product.id
    //     const uniqueProductsMap = new Map();
    //     allProducts.forEach((product) => {
    //         if (!uniqueProductsMap.has(product.id)) {
    //             uniqueProductsMap.set(product.id, product);
    //         }
    //     });

    //     const uniqueProducts = Array.from(uniqueProductsMap.values());

    //     // Step 3: Filter based on search query
    //     const matchedProducts = uniqueProducts.filter((item) =>
    //         Object.values(item).some(
    //             (val) =>
    //                 typeof val === 'string' &&
    //                 val.toLowerCase().includes(value.toLowerCase())
    //         )
    //     );

    //     // Optional: group back by category if needed, or just send flat array
    //     setFilteredSuggestions({ results: matchedProducts });

    //     // const debounce = setTimeout(fetchData, 300);
    //     // return () => clearTimeout(debounce);
    // }, [query]);
    useEffect(() => {
        if (fullData) {
            const index = buildSearchIndex(fullData);
            setSearchIndex(index);
        }
    }, [fullData]);


    useEffect(() => {
        if (!query.trim()) {
            setFilteredSuggestions([]);
            return;
        }

        const value = query.toLowerCase();
        const results = searchIndex.filter(item =>
            item._searchText.includes(value)
        );

        setFilteredSuggestions(results);
    }, [query, searchIndex]);


    const navigateByType = (item) => {
        switch (item.type) {
            case "product":
                return navigate(`/product/${item.slug}`);

            case "pandit":
                return navigate(`/pandit/${item.user_name}`);

            case "astrologer":
                return navigate(`/astrologer/${item.user_name}`);

            case "category":
                return navigate(`/${item.slug}`);

            case "blogs":
                return navigate(`/blog/${item.slug}`);

            default:
                return;
        }
    };


    useEffect(() => {
        dispatch(fetchMasterData());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchSettingData());
    }, [dispatch]);

    // const allowedPages = ["horoscope", "today-horoscope", "love-horoscope", "yesterday-horoscope", "tomorrow-horoscope", "weekly-horoscope", "monthly-horoscope", "yearly-horoscope"];
    const Horoscope = horoscopePages?.find((item) => item?.page_name === "horoscope")
    const TodayHoroscope = horoscopePages?.find((item) => item?.page_name === "today-horoscope")
    const LoveHoroscope = horoscopePages?.find((item) => item?.page_name === "love-horoscope")
    const YesterDayHoroscope = horoscopePages?.find((item) => item?.page_name === "yesterday-horoscope")
    const TomorrowHoroscope = horoscopePages?.find((item) => item?.page_name === "tomorrow-horoscope")
    const WeeklyHoroscope = horoscopePages?.find((item) => item?.page_name === "weekly-horoscope")
    const MonthlyHoroscope = horoscopePages?.find((item) => item?.page_name === "monthly-horoscope")
    const YearlyHoroscope = horoscopePages?.find((item) => item?.page_name === "yearly-horoscope")
    const LoveCalculator = horoscopePages?.find((item) => item?.page_name === "love-calculator")

    // <------------- Get the User Active ---------->
    const is_user_active = localStorage.getItem("user_is_active")

    const toggleDropdown = () => {
        setIs_Language_Open(!is_language_Open);
    };

    const selectLanguage = (language) => {
        setSelectedLanguage(language);
        setIs_Language_Open(false);
    };

    // Sync the local state cart_list with the Redux cartlist when it changes
    useEffect(() => {
        set_Cart_List(cartlist);
    }, [cartlist]);


    // Dispatch Redux action to fetch profile data
    useEffect(() => {
        dispatch(fetchCartList());
    }, [dispatch]);

    useEffect(() => {
        const get_wishlist = async () => {
            const result = await dispatch(fetchWishlist());
            if (result?.unauthorized) {
                localStorage.removeItem("user_token");
                localStorage.removeItem("user_is_active");

            }
        }
        get_wishlist();
    }, [dispatch]);

    // <--------- Add To Favorite --------->
    const Handle_add_to_favorite = async (cat_id, sub_id, id) => {
        set_Is_Loading(true)
        const data = {
            cat_id: cat_id,
            subcat_id: sub_id,
            product_id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User not login here")
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            if (!Get_user_is_active) {
                set_Is_Loading(false);
                toast("User not login here")
                return
            }
            const response = await Add_To_Fav(data, { Authorization: `Bearer ${token}` })
            if (response?.status == 200) {

                // await handle_get_favourite_product_list({ Authorization: `Bearer ${token}` })
                set_Is_Loading(false)
                dispatch(fetchWishlist())

                toast("remove the product from wishlist !!")
            } else if (response?.response?.data?.status == 401) {
                set_Is_Loading(false)
                localStorage.removeItem("user_token");
                localStorage.removeItem("user_is_active");
                toast("Token Expired. Please Login Again.");
                dispatch(fetchWishlist())

                navigate("/user-login");
                return;
            }
            else if (response?.response?.data?.status == 500) {
                set_Is_Loading(false)
                toast(response?.response?.data?.message)
            }
        }
        catch (error) {
            console.error("error", error)
            set_Is_Loading(false)
        } finally {
            set_Is_Loading(false)
        }
    }

    const toggleOffcanvas = () => {
        setIsCartOpen(!isCartOpen);
    };

    const handle_get_category_list = async () => {
        try {
            const response = await Category_List()
            if (response?.data?.status == 200) {
                setCategoryList(response?.data?.data?.
                    category)
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        handle_get_category_list()
    }, [])

    const gemstoneCategory = categorylist.find(item => item.id === 1);
    const jewelleryCategory = categorylist.find(item => item.id === 2);

    useEffect(() => {
        if (categorylist.length === 0) return;
        const fetchSubcategories = async (catId, setSubcategoryState) => {
            try {
                const response = await Sub_Category_List({ cat_id: catId });
                if (response?.data?.status === 200) {
                    setSubcategoryState(response.data.data.sub_category);
                } else {
                    console.warn(`Unexpected response for category ${catId}:`, response.data);
                }
            } catch (error) {
                console.error(`Failed to fetch subcategories for category ${catId}:`, error);
            }
        };
        if (gemstoneCategory) {
            fetchSubcategories(gemstoneCategory.id, setGemstoneSubCategoryList);
        }

        if (jewelleryCategory) {
            fetchSubcategories(jewelleryCategory.id, setJewellerySubCategoryList);
        }
    }, [categorylist]);

    const sorted_GemstoneSubcategory = [...gemstone_subcategorylist].sort((a, b) =>
        a?.title.localeCompare(b?.title)
    );

    const sorted_JewellerySubcategory = [...jewellery_subcategorylist].sort((a, b) =>
        a?.title.localeCompare(b?.title)
    );

    const groupedByType = sorted_GemstoneSubcategory.reduce((acc, item) => {
        const type = item?.type;
        if (!type?.id || !type?.name || type?.name === "null" || type?.name === "undefined") {
            return acc; // skip invalid
        }
        if (!acc[type.id]) {
            acc[type.id] = { name: type.name, items: [] };
        }
        acc[type.id].items.push(item);
        return acc;
    }, {});

    const groupedByTypeJewellery = sorted_JewellerySubcategory.reduce((acc, item) => {
        const type = item?.type;
        if (!type?.id || !type?.name || type?.name === "null" || type?.name === "undefined") {
            return acc; // Skip invalid types
        }
        if (!acc[type.id]) {
            acc[type.id] = { name: type.name, items: [] };
        }
        acc[type.id].items.push(item);
        return acc;
    }, {});

    let globalIndex = -1;

    useEffect(() => {
        function handleClickOutside(e) {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setIsOpen(false);   // hide only
                setActiveIndex(-1);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    console.log("isOpen ", isOpen);

    return (
        <div>
            <div className="fixed w-full top-0 left-0 right-0 z-30">
                {/* <CartProvider> */}
                <header className="gi-header bg-[#fff] z-[14] max-[991px]:z-[16] relative">
                    {/* <!-- Header Top Start --> */}
                    <div className="header-top py-[15px] md:py-[5px] text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500]">
                        <div
                            className="flex flex-wrap justify-between items-center mx-auto min-[1600px]:max-w-[1480px] min-[1400px]:max-w-[1350px] min-[1200px]:max-w-[1190px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full flex flex-wrap px-[12px]">
                                {/* <!-- Header Top social Start --> */}
                                <div className="grow-[1] shrink-[0] basis-[0%] min-[992px]:block max-[992px]:hidden pt-1">
                                    <div className="header-top-social">
                                        <ul className="mb-[0] p-[0] flex">
                                            <li
                                                className="list-inline-item  flex text-[13px] mr-[15px]">
                                                <Link to="/astrologer-list"
                                                    className="mx-[5px] text-center flex items-center justify-center items-center capitalize font-medium">
                                                    <i className="fi-rr-comment text-[14px] text-[#fff] mr-2"></i>
                                                    Chat / Call Astrologer
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* <!-- Header Top social End --> */}
                                <div className="grow-[1] shrink-[0] basis-[0%] hidden min-[992px]:block">
                                    <div className="header-top-right-inner flex justify-end items-center">
                                        <div className="relative mr-[20px] " ref={searchRef}>
                                            {!showInput && (
                                                <button onClick={handleToggle} className="flex items-center gap-1">
                                                    <Search size={13} />
                                                    <span className="text-[13px] capitalize font-medium">Search</span>
                                                </button>
                                            )}
                                            {showInput && (
                                                <>
                                                    <input
                                                        type="text"
                                                        value={query}
                                                        onChange={(e) => {
                                                            setQuery(e.target.value)
                                                            setActiveIndex(-1);
                                                            setIsOpen(true);
                                                        }}
                                                        onFocus={() => {
                                                            if (query) setIsOpen(true);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (!filteredSuggestions.length) return;

                                                            if (e.key === "ArrowDown") {
                                                                e.preventDefault();
                                                                setActiveIndex(i => Math.min(i + 1, filteredSuggestions.length - 1));
                                                            }

                                                            if (e.key === "ArrowUp") {
                                                                e.preventDefault();
                                                                setActiveIndex(i => Math.max(i - 1, 0));
                                                            }

                                                            if (e.key === "Enter") {
                                                                if (activeIndex >= 0) {
                                                                    const item = filteredSuggestions[activeIndex];
                                                                    navigateByType(item);
                                                                    setQuery("");
                                                                    setIsOpen(false);
                                                                }
                                                            }

                                                            if (e.key === "Escape") {
                                                                setQuery("");
                                                            }
                                                        }}
                                                        ref={inputRef}
                                                        placeholder="Search..."
                                                        className="w-64 p-1 px-2 text-[13px] border text-gray-600 border-red-300 rounded-t"
                                                    />
                                                    {isOpen && query && (
                                                        <div className="absolute z-10 w-full bg-white border border-t-0 border-gray-200 rounded-b shadow max-h-72 overflow-y-auto">

                                                            {is_loading && (
                                                                <div className="px-4 py-3 text-gray-600">Loading...</div>
                                                            )}

                                                            {!is_loading && filteredSuggestions.length === 0 && (
                                                                <div className="px-4 text-sm py-3 text-gray-600">
                                                                    No results found
                                                                </div>
                                                            )}

                                                            {!is_loading &&
                                                                filteredSuggestions.map((item, index) => {
                                                                    const isActive = index === activeIndex;

                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className={`flex items-start gap-3 p-3 border-b last:border-none cursor-pointer
              ${isActive ? "bg-gray-200" : "hover:bg-gray-100"}
            `}
                                                                            onClick={() => {
                                                                                navigateByType(item);
                                                                                setQuery("");
                                                                                setIsOpen(false);
                                                                            }}
                                                                        >
                                                                            {item?.profile_image && (
                                                                                <img
                                                                                    src={`${IMG_BASE_URL}${item.profile_image}`}
                                                                                    alt={item.name || item.username}
                                                                                    className="w-12 h-12 object-cover"
                                                                                />
                                                                            )}

                                                                            {item?.image && (
                                                                                <img
                                                                                    src={`${IMG_BASE_URL}${item.image}`}
                                                                                    alt={item.image_alt || item.alt_image_title}
                                                                                    className="w-12 h-12 object-cover"
                                                                                />
                                                                            )}
                                                                            {item?.single_image?.image_url && (
                                                                                <img
                                                                                    src={`${IMG_BASE_URL}${item.single_image.image_url}`}
                                                                                    alt={item.name || item.username}
                                                                                    className="w-12 h-12 object-cover"
                                                                                />
                                                                            )}

                                                                            <div>
                                                                                <p className="text-[11px] uppercase text-gray-500">
                                                                                    {item.type}
                                                                                </p>

                                                                                <p className="text-[13px] font-medium text-gray-800">
                                                                                    {item.name || item.username || item.title}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    )}


                                                </>
                                            )}
                                        </div>
                                        {/* <!-- Header User Start --> */}
                                        <div className="gi-header-bottons">
                                            <div className={`relative ${is_user_active ? "gi-acc-drop" : "gi-acc-drop"}`}>
                                                <a href="javascript:void(0)"
                                                    className="gi-header-btn gi-header-user dropdown-toggle gi-user-toggle mr-[20px]  
                                             relative flex text-black w-[auto] items-center whitespace-nowrap"
                                                    title="Account">
                                                    <div className="header-icon relative flex">
                                                        <i className="fi-rr-user text-[#fff] text-[15px] leading-[17px]"></i>
                                                    </div>
                                                    {
                                                        is_user_active ? (
                                                            <div className="gi-btn-desc flex flex-col ml-[5px] md:block hidden">
                                                                <Link to="/user-dashBaord"
                                                                    className="gi-btn-title text-[13px] leading-[1]
                                                             text-[#fff] capitalize font-medium">Account</Link>
                                                            </div>
                                                        ) : (
                                                            <div className="gi-btn-desc flex flex-col ml-[5px] ">
                                                                <span
                                                                    className="gi-btn-title  text-[13px] leading-[1]
                                                         text-[#fff] capitalize font-medium">Account</span>
                                                            </div>
                                                        )
                                                    }
                                                </a>
                                                {
                                                    is_user_active ? (
                                                        <ul className={`gi-dropdown-menu min-w-[200px] py-[5px] top-2 absolute z-[16] text-left bg-[#fff]
                                                            block ${open ? 'opacity-100 visible' : 'opacity-0 invisible'} left-[0] right-[auto] border-[1px] border-solid border-[#eee] rounded-[5px]`}>
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225] modal-toggle" tabIndex="0" to="/user-profile">
                                                                    Profile
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225]" to="/user-logout">
                                                                    Logout
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    ) : (
                                                        <ul className={`gi-dropdown-menu min-w-[200px] py-[5px] top-2 absolute z-[16] text-left bg-[#fff]
                                                             block ${open ? 'opacity-100 visible' : 'opacity-0 invisible'} left-[0] right-[auto] border-[1px] border-solid border-[#eee] rounded-[5px]`}>
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225] modal-toggle" tabIndex="0" to="/user-login">
                                                                    Login
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                                                                    to="/user-register"
                                                                    onClick={() => setOpen(true)}  // Change to React event handler
                                                                >
                                                                    Register
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225]" to="/astrologer-login">Astrologer/Pandit Login</Link>
                                                            </li>
                                                            <li>
                                                                <Link
                                                                    className="dropdown-item py-[10px] px-[15px] block w-full font-medium text-[13px] text-gray-800 hover:bg-transparent hover:text-[#9F2225]"
                                                                    to="/astrologer-register"
                                                                >
                                                                    Astrologer/Pandit Registration
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    )
                                                }

                                            </div>
                                        </div>


                                        <div className="relative wishlist_btn mr-[20px] group">
                                            {is_user_active ? <span
                                                className=" relative flex text-black w-[auto] items-center whitespace-nowrap cursor-pointer"
                                                title="Wishlist">
                                                <div className="header-icon relative flex">
                                                    <i className="fi-rr-heart text-[15px] text-[#fff] leading-[17px]"></i>
                                                </div>
                                                <div className="gi-btn-desc flex flex-col ml-[5px]">
                                                    {
                                                        wishlist?.length > 0 && (
                                                            <span
                                                                className="gi-header-count gi-wishlist-count w-[15px] h-[15px] text-blue-400 flex items-center justify-center
                                                         rounded-[50%] text-[13px] bg-white absolute top-[-2px] right-[-6px] opacity-[0.8]">{wishlist?.length}</span>
                                                        )
                                                    }
                                                    <span className="gi-btn-title  text-[13px] leading-[1]
                                                         text-[#fff] capitalize font-medium">Wishlist</span>
                                                </div>
                                            </span>
                                                : <Link to="/user-login"
                                                    className=" relative flex text-black w-[auto] items-center whitespace-nowrap cursor-pointer"
                                                    title="Wishlist">
                                                    <div className="header-icon relative flex">
                                                        <i className="fi-rr-heart text-[15px] text-[#fff] leading-[17px]"></i>
                                                    </div>
                                                    <div className="gi-btn-desc flex flex-col ml-[5px]">
                                                        {
                                                            wishlist?.length > 0 && (
                                                                <span
                                                                    className="gi-header-count gi-wishlist-count w-[15px] h-[15px] text-blue-400 flex items-center justify-center
                                                     rounded-[50%] text-[13px] bg-white absolute top-[-2px] right-[-6px] opacity-[0.8]">{wishlist?.length}</span>
                                                            )
                                                        }
                                                        <span className="gi-btn-title  text-[13px] leading-[1]
                                                     text-[#fff] capitalize font-medium">Wishlist</span>
                                                    </div>
                                                </Link>}

                                            {is_user_active &&
                                                <div className="wish_list w-[350px] opacity-0 invisible group-hover:visible group-hover:opacity-100  duration-[0.4s] bg-white shadow-xl z-30 absolute top-8 right-0">
                                                    <div className="gi-cart-inner relative z-[9] flex flex-col h-full justify-between items-center">
                                                        <div className="gi-cart-title py-3 w-full flex flex-wrap justify-between items-center px-[20px]">
                                                            <span className="cart_title text-[15px] text-black font-Poppins font-medium">
                                                                Wishlist</span>
                                                        </div>
                                                        <div className="gi-cart-top">

                                                            <ul className="gi-cart-pro-items bg-[#F6F6F6] p-[10px] overflow-y-auto max-h-[calc(100vh-170px)]">
                                                                {wishlist?.length > 0 ? (
                                                                    wishlist.map((listItem) => (
                                                                        <li
                                                                            key={listItem?.product_id} // unique key dena zaroori hai
                                                                            className="mb-[15px] p-[15px] flex overflow-hidden bg-white rounded-[5px]"
                                                                        >
                                                                            <a
                                                                                href="/user-wishlist"
                                                                                className="gi-pro-img flex grow-[1] basis-[20%] items-center"
                                                                            >
                                                                                <img
                                                                                    src={`${IMG_BASE_URL}${listItem?.product?.single_image?.image_url}`}
                                                                                    className="w-full"
                                                                                    alt={listItem?.product?.name || "product"}
                                                                                />
                                                                            </a>

                                                                            <div className="gi-pro-content relative grow-[1] basis-[70%] pl-[15px] overflow-hidden">
                                                                                <a
                                                                                    href="/user-wishlist"
                                                                                    className="cart-pro-title w-full font-bold pr-[30px] text-[#000] whitespace-normal text-ellipsis block text-[13px] font-medium line-clamp-2"
                                                                                >
                                                                                    {listItem?.product?.name}
                                                                                </a>

                                                                                <span className="cart-price text-[#000] font-bold text-[14px] block mt-[5px]">
                                                                                    {listItem?.product?.seller_price}
                                                                                </span>
                                                                            </div>

                                                                            <MdDelete
                                                                                size={20}
                                                                                className="text-red-600 cursor-pointer"
                                                                                onClick={() => {
                                                                                    if (window.confirm("Are you sure?")) {
                                                                                        Handle_add_to_favorite(
                                                                                            listItem?.cat_id,
                                                                                            listItem?.subcat_id,
                                                                                            listItem?.product_id
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </li>
                                                                    ))
                                                                ) : (
                                                                    <div className='text-black text-sm'>Your Wishlist is currently Empty.</div>
                                                                )}
                                                            </ul>
                                                        </div>
                                                        <div className="gi-cart-bottom w-full p-3">
                                                            <div className="cart_btn w-full">
                                                                <a href="/user-wishlist" className="gi-btn-2 w-full h-[40px] block uppercase font-medium text-[13px] py-[8px] px-[15px] leading-[22px] bg-[#9F2225] text-[#fff] text-center rounded-[5px]  dummy-[0.3s] hover:bg-[#4B5966]">Wishlist</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                        </div>

                                        {/* <!-- Header Cart Start --> */}
                                        <span
                                            className="gi-header-btn gi-cart-toggle  relative flex text-black w-[auto] items-center whitespace-nowrap "
                                        >
                                            <div className="header-icon relative flex">
                                                <span
                                                    className="main-label-note-new 
                                                 h-[10px] w-[10px] m-auto bg-[#ec716d] rounded-[50%] cursor-default hidden 
                                                 absolute bottom-[15px] left-[0] right-[0] z-[3]"></span>
                                            </div>
                                            <div className="gi-btn-desc flex flex-col uppercase ml-[5px]">
                                                <span
                                                    className="gi-btn-title  text-[13px] 
                                                leading-[1] text-[#fff] uppercase font-medium cursor-pointer"  title="cart">
                                                    {
                                                        is_user_active ? <span className='flex items-center gap-2' onClick={toggleOffcanvas}>
                                                            <i className="fi-rs-shopping-cart text-[#fff] text-[15px] leading-[17px]" >
                                                            </i></span> : <Link className='flex items-center gap-2' to="/user-login" >
                                                            <i className="fi-rs-shopping-cart text-[#fff] text-[15px] leading-[17px]"></i> Cart</Link>
                                                    }
                                                    {
                                                        cart_list?.length > 0 && (
                                                            <span
                                                                className="gi-header-count gi-cart-count  w-[15px] h-[15px] text-blue-400 flex items-center
                                                             justify-center rounded-lg bg-white text-[13px]  absolute top-[-2px] right-[-6px] opacity-[0.8]">{cart_list?.length}</span>
                                                        )
                                                    }

                                                </span>

                                            </div>
                                            {isCartOpen && <Cart_Sidebar toggleOffcanvas={toggleOffcanvas} />}

                                        </span>
                                        {/* <!-- Header Cart End --> */}

                                        {/* <!-- Language Start --> */}
                                        <div
                                            className="relative bg-[#BC7C04] ml-5 py-1 px-2 rounded cursor-pointer"
                                            onClick={toggleDropdown}
                                        >
                                            <button
                                                type="button"
                                                className="text-[13px] flex items-center justify-between w-full text-[#fff] border-[0] outline-none focus-within:outline-0"
                                            >
                                                {/* {selectedLanguage} */}
                                                INR
                                                {/* <i className="fi-rr-angle-small-down text-[14px] ml-[5px] text-[#fff]"></i> */}
                                            </button>
                                            {/* {is_language_Open && (
                                                    <ul
                                                        className="absolute top-full left-0 mt-2 min-w-[130px] truncate bg-[#fff] z-[1] rounded-[5px] border-[1px] border-solid border-[#eee] shadow-md"
                                                    >
                                                        <li
                                                            className={`${selectedLanguage === "English"
                                                                ? "bg-gray-200 font-medium"
                                                                : ""
                                                                } border-b-[1px] border-solid border-[#eee] leading-[1.5] py-[5px]`}
                                                        >
                                                            <button
                                                                className="w-full text-left text-gray-800 text-[13px] bg-transparent px-2"
                                                                onClick={() => selectLanguage("English")}
                                                            >
                                                                English
                                                            </button>
                                                        </li>
                                                        <li
                                                            className={`${selectedLanguage === "Italiano"
                                                                ? "bg-gray-200 font-medium"
                                                                : ""
                                                                } leading-[1.5] py-[5px]`}
                                                        >
                                                            <button
                                                                className="w-full text-left text-gray-800 text-[13px] bg-transparent px-2"
                                                                onClick={() => selectLanguage("Italiano")}
                                                            >
                                                                Italiano
                                                            </button>
                                                        </li>
                                                        <li
                                                            className={`${selectedLanguage === "Hindi"
                                                                ? "bg-gray-200 font-medium"
                                                                : ""
                                                                } leading-[1.5] py-[5px]`}
                                                        >
                                                            <button
                                                                className="w-full text-left text-gray-800 text-[13px] bg-transparent px-2"
                                                                onClick={() => selectLanguage("Hindi")}
                                                            >
                                                                Hindi
                                                            </button>
                                                        </li>
                                                    </ul>
                                                )} */}
                                        </div>
                                        {/* <!-- Language End --> */}

                                    </div>
                                </div>
                                {/* <!-- Header Top responsive Action --> */}
                                <div className="grow-[1] shrink-[0] basis-[0%] min-[992px]:hidden">
                                    <div className="gi-header-bottons flex justify-between">
                                        <div className="ps-10 min-[992px]:hidden">
                                            <Link to="/">
                                                {
                                                    settingData && settingData[0]?.header_logo != null ? (
                                                        <img src={`${IMG_BASE_URL}${settingData[0]?.header_logo}`} alt={settingData[0]?.alt_image}
                                                            className="w-[100px] max-[1199px]:w-[80px] max-[991px]:w-[70px] max-[767px]:w-[70px] " />
                                                    ) : (
                                                        <img src={Common_Images_Transport.logo} alt="Site Logo"
                                                            className="w-[100px] max-[1199px]:w-[80px] max-[991px]:w-[70px] max-[767px]:w-[70px] " />
                                                    )
                                                }
                                            </Link>
                                        </div>
                                        <div className="right-icons flex flex-row">

                                            {/* <!-- Header User Start --> */}
                                            <Link to="/user-profile"
                                                className="gi-header-btn gi-header-user mr-[20px] relative  relative 
                                                flex text-[#fff] w-[auto] items-center">
                                                <div className="header-icon relative flex">
                                                    <i className="fi-rr-user text-[20px] leading-[17px]"></i>
                                                </div>
                                                {
                                                    is_user_active ? (
                                                        <div className="gi-btn-desc flex flex-col uppercase ml-[5px]">
                                                            <Link to="/user-dashBaord"
                                                                className="gi-btn-title text-[13px] leading-[1]
                                                             text-[#fff] uppercase font-medium">Account</Link>
                                                        </div>
                                                    ) : (
                                                        <div className="hidden md:block gi-btn-desc flex flex-col uppercase ml-[5px]">
                                                            <span
                                                                className="gi-btn-title  text-[13px] leading-[1]
                                                         text-[#fff] uppercase font-medium">Account</span>
                                                        </div>
                                                    )
                                                }
                                            </Link>
                                            {/* <!-- Header User End --> */}
                                            {/* <!-- Header Wishlist Start --> */}
                                            <Link to="/user-wishlist"
                                                className="gi-header-btn gi-wish-toggle mr-[20px] relative  relative flex text-[#fff] w-[auto] items-center">
                                                <div className="header-icon relative flex">
                                                    <i className="fi-rr-heart text-[20px] leading-[17px]"></i>
                                                </div>
                                                {
                                                    wishlist?.length > 0 && (
                                                        <span
                                                            className="gi-header-count gi-wishlist-count w-[15px] h-[15px] text-[#fff] flex items-center justify-center
                                                         rounded-[50%] text-[13px] absolute top-[-2px] right-[-6px] opacity-[0.8]">{wishlist?.length}</span>
                                                    )
                                                }

                                            </Link>
                                            {/* <!-- Header Wishlist End --> */}

                                            {/* <!-- Header Cart Start --> */}
                                            <a href="javascript:void(0)"
                                                className="gi-header-btn gi-cart-toggle mr-[20px] relative  relative flex text-[#fff] w-[auto] items-center">
                                                <div className="header-icon relative flex">

                                                    {
                                                        is_user_active ? <Link className='flex items-center gap-2' to="/cart">
                                                            <i className="fi-rs-shopping-cart text-[#fff] text-[20px] leading-[17px]">
                                                            </i></Link> : <Link className='flex items-center gap-2' to="/user-login" >
                                                            <i className="fi-rs-shopping-cart text-[#fff] text-[20px] leading-[17px]"></i></Link>
                                                    }
                                                </div>
                                                {
                                                    cart_list?.length > 0 && (
                                                        <span
                                                            className="gi-header-count gi-cart-count  w-[15px] h-[15px] text-[#fff] flex items-center
                                                             justify-center rounded-[50%] text-[13px] absolute top-[-2px] right-[-6px] opacity-[0.8]">{cart_list?.length}</span>
                                                    )
                                                }
                                            </a>
                                            {/* <!-- Header Cart End --> */}
                                            {/* <!-- Header menu Start --> */}

                                            <Mobile_Toggle gemstone_subcategorylist={gemstone_subcategorylist} jewellery_subcategorylist={jewellery_subcategorylist} more_Categories={more_Categories} categorylist={categorylist} horoscopePages={horoscopePages} />
                                            {/* <!-- Header menu End --> */}
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- Header Top responsive Action --> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- Header Top  End --> */}

                    {/* <!-- Header Bottom  Start --> */}
                    <div
                        className="gi-header-bottom max-[992px]:hidden py-[4px] max-[991px]:py-[15px] shadow-lg">
                        <div
                            className="flex flex-wrap justify-between relative items-center mx-auto min-[1600px]:max-w-[1480px] min-[1400px]:max-w-[1350px] min-[1200px]:max-w-[1190px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="w-full flex flex-wrap px-[12px]">
                                <div className="gi-flex flex flex-row justify-between w-full max-[575px]:flex-col">
                                    {/* <!-- Header Logo Start --> */}
                                    <div className="self-center gi-header-logo">
                                        <div className="header-logo text-left">
                                            <Link to="/">
                                                {
                                                    settingData && settingData[0]?.header_logo != null ? (
                                                        <img src={`${IMG_BASE_URL}${settingData[0]?.header_logo}`} alt={settingData[0]?.alt_image}
                                                            fetchpriority="high"
                                                            decoding="async"
                                                            loading="eager"
                                                            className="w-[150px] max-[1199px]:w-[100px] max-[991px]:w-[120px] max-[767px]:w-[100px] " />
                                                    ) : (
                                                        <img src={Common_Images_Transport.logo} alt="Site Logo"
                                                            className="w-[150px] max-[1199px]:w-[100px] max-[991px]:w-[120px] max-[767px]:w-[100px] " />
                                                    )
                                                }
                                            </Link>
                                        </div>
                                    </div>
                                    {/* <!-- Header Logo End --> */}
                                    {/* <!-- Main Menu Start --> */}
                                    <div id="gi-main-menu-desk" className="w-full flex items-center min-[992px]:block hidden">
                                        <div className="nav-desk">
                                            <div className="w-full flex flex-wrap px-[12px] min-[1400px]:relative">
                                                <div className="basis-auto w-full self-center">
                                                    <div className="gi-main-menu flex">
                                                        <ul className="menu_size w-full flex justify-center flex-wrap pl-[0]">
                                                            <li

                                                                className="dropdown drop-list relative px-2.5"
                                                                onMouseEnter={() => setIsDropdownOpen(true)}
                                                                onMouseLeave={() => setIsDropdownOpen(false)}>
                                                                <Link to={`/${gemstoneCategory?.slug}`}

                                                                    className="dropdown-arrow relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-900 flex items-center gap-1 font-bold cursor-pointer">
                                                                    Gemstone<i
                                                                        className="fi-rr-angle-small-right rotate-[90deg]"></i></Link>

                                                                {isDropdownOpen && gemstone_subcategorylist?.length > 0 && (
                                                                    <div className="menu_all_gemstone hidden">
                                                                        <ul className="sub-menu lg:grid grid-cols-5">
                                                                            {Object.entries(groupedByType).map(([typeId, group]) => (
                                                                                <li key={typeId} className="all_menus">
                                                                                    <div
                                                                                        className="title_heading text-[13px] text-dark font-medium cursor-pointer"
                                                                                        onClick={() => {
                                                                                            navigate(`/${gemstoneCategory?.slug}`, {
                                                                                                state: { typeId: Number(typeId) },
                                                                                            });
                                                                                            setIsDropdownOpen(false);
                                                                                        }}
                                                                                    >
                                                                                        <span>{group.name}</span>
                                                                                    </div>
                                                                                    <ul>
                                                                                        {group.items.map((sub_category_result) => (
                                                                                            <li key={sub_category_result.id} className="cursor-pointer">
                                                                                                <Link to={`/${gemstoneCategory?.slug}/${sub_category_result?.slug}`}>
                                                                                                    <span>
                                                                                                        <img
                                                                                                            alt={sub_category_result?.image_alt}
                                                                                                            src={`${IMG_BASE_URL}${sub_category_result?.image}`}
                                                                                                        />
                                                                                                    </span>
                                                                                                    {sub_category_result?.title}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </li>
                                                                            ))}

                                                                        </ul>
                                                                    </div>
                                                                )}

                                                            </li>
                                                            <li

                                                                className="dropdown drop-list relative px-2.5"
                                                                onMouseEnter={() => setIsDropdownOpen(true)}
                                                                onMouseLeave={() => setIsDropdownOpen(false)}>
                                                                <Link to={`/${jewelleryCategory?.slug}`}

                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-900 flex items-center gap-1 font-bold cursor-pointer">
                                                                    Jewellery<i
                                                                        className="fi-rr-angle-small-right rotate-[90deg]"></i></Link>
                                                                {isDropdownOpen && jewellery_subcategorylist?.length > 0 && (
                                                                    <div className="menu_all_gemstone hidden">
                                                                        <ul className="sub-menu lg:grid grid-cols-5">
                                                                            {Object.entries(groupedByTypeJewellery).map(([typeId, group]) => (
                                                                                <li key={typeId} className="all_menus">
                                                                                    <div
                                                                                        className="title_heading text-[13px] text-dark font-medium cursor-pointer"
                                                                                        onClick={() => {
                                                                                            navigate(`/${jewelleryCategory?.slug}`, { state: { typeId: Number(typeId) } })
                                                                                            setIsDropdownOpen(false);
                                                                                        }
                                                                                        }
                                                                                    >
                                                                                        <span>{group.name}</span>
                                                                                    </div>
                                                                                    <ul>
                                                                                        {group.items.map((sub_category_result) => (
                                                                                            <li key={sub_category_result.id} className="cursor-pointer">
                                                                                                <Link to={`/${jewelleryCategory?.slug}/${sub_category_result?.slug}`}>
                                                                                                    <span>
                                                                                                        <img
                                                                                                            alt={sub_category_result?.image_alt}
                                                                                                            src={`${IMG_BASE_URL}${sub_category_result?.image}`}
                                                                                                        />
                                                                                                    </span>
                                                                                                    {sub_category_result?.title}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </li>
                                                                            ))}

                                                                        </ul>

                                                                    </div>
                                                                )}

                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to="/recommend-gemstone"
                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center font-medium">
                                                                    Gem Recommendation
                                                                </Link>
                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to="/custom-jewelry" className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center font-medium">custom jewellery</Link>

                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to={undefined}
                                                                    onClick={(e) => e.preventDefault()}
                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center gap-1 font-medium">Daily
                                                                    Horoscope<i
                                                                        className="fi-rr-angle-small-right rotate-[90deg]"></i></Link>
                                                                <ul
                                                                    className="sub-menu  mt-[15px] absolute z-[16] text-left opacity-0 invisible min-w-[205px] left-0 right-auto bg-[#fff] block rounded-[5px] border-[1px] border-solid border-[#eee] py-[5px]">
                                                                    <li><Link to={`/horoscope/${Horoscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${TodayHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Today Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${LoveHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Love Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${YesterDayHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Yesterday Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${TomorrowHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Tomorrow's Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${WeeklyHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Weekly Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${MonthlyHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Monthly Horoscope</Link></li>
                                                                    <li><Link to={`/horoscope/${YearlyHoroscope?.slug}`}
                                                                        className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-between items-center hover:text-[#9F2225]">Yearly Horoscope</Link></li>
                                                                </ul>
                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to={`/page/${LoveCalculator?.slug}`}
                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center font-medium">Love
                                                                    Calculator</Link>
                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to="/pooja"
                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center font-medium">Book Pooja</Link>
                                                            </li>
                                                            <li
                                                                className="dropdown drop-list relative px-2.5">
                                                                <Link to="#"
                                                                    className="dropdown-arrow capitalize relative  sm:text-[9px] md:text-[10px] lg:text-[13px] xl:text-[13px] leading-[58px] text-gray-800 flex items-center gap-1 font-medium">More<i
                                                                        className="fi-rr-angle-small-right rotate-[90deg]"></i></Link>
                                                                <ul
                                                                    className="sub-menu  mt-[15px] absolute z-[16] text-left opacity-0 invisible w-[250px] left-auto -right-12 bg-[#fff] block rounded-[5px] border-[1px] border-solid border-[#eee] py-[5px]">
                                                                    {more_Categories?.map((more_type, ind) => (
                                                                        <li key={ind + 1}><Link to={`/${more_type?.slug}`}
                                                                            className=" leading-[20px] px-[20px] py-[6px] font-medium text-[13px] text-gray-600 flex justify-start gap-3 items-center hover:text-[#9F2225]">
                                                                            <span >
                                                                                <img alt={more_type?.image_alt
                                                                                } src={`${IMG_BASE_URL}${more_type?.image}`} className='max-w-6' /></span>
                                                                            {more_type?.title}
                                                                        </Link></li>
                                                                    ))}
                                                                </ul>

                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- Main Menu End --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Header Button End --> */}



                    {/* <!-- Mobile Menu sidebar Start --> */}
                    <div className="gi-mobile-menu-overlay hidden w-full h-screen fixed top-[0] left-[0] bg-[#000000cc] z-[16]"></div>
                    <div id="gi-mobile-menu"
                        className="gi-mobile-menu  w-[340px] h-full pt-[15px] pb-[20px] px-[20px] fixed top-[0] right-[auto] left-[0] bg-[#fff] flex flex-col z-[17] overflow-auto max-[480px]:w-[300px]">
                        <div className="gi-menu-title w-full pb-[10px] flex flex-wrap justify-between">
                            <span className="menu_title flex items-center text-[16px] text-black font-medium"> <img
                                src={Common_Images_Transport?.logo} alt="site-logo" /> </span>
                            <button type="button"
                                className="gi-close-menu relative text-[30px] leading-[1] text-gray-600 bg-transparent border-0 mx-[5px]">×</button>
                        </div>
                        <div className="gi-menu-inner">
                            <div className="gi-menu-content">
                                <ul>
                                    <li className="dropdown relative drop-list">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow mb-[12px] p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Free
                                            Kundli</a>

                                    </li>

                                    <li className="dropdown relative">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow mb-[12px] p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Daily
                                            Horoscope</a>
                                        <ul
                                            className="sub-menu w-full min-w-[auto] p-0 mb-[10px] static  visible transition-none opacity-[1]">
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Horoscope
                                                2024</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Today's
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Weekly
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Monthly
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Yearly
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Daily
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Tomorrow's
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Yesterday's
                                                Horoscope</a></li>
                                            <li><a href="#"
                                                className="mb-[0] pl-[15px] pr-[0] py-[12px] block text-[14px] font-medium text-gray-600">Chinese
                                                Horoscope</a></li>
                                        </ul>
                                    </li>
                                    <li className="relative">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow mb-[12px] p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Daily
                                            Panchang</a>

                                    </li>

                                    <li className="relative">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Love
                                            calculator</a>

                                    </li>
                                    <li className="relative mt-3">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Kundli
                                            Matching</a>

                                    </li>
                                    <li className="relative mt-3">
                                        <a href="javascript:void(0)"
                                            className="dropdown-arrow p-[12px] block text-gray-600 border-[1px] border-solid border-[#eee] rounded-[5px] text-[15px] font-medium">Nakshtra
                                            Mall</a>

                                    </li>
                                </ul>
                            </div>
                            <div className="header-res-lan-curr">
                                {/* <!-- Social Start --> */}
                                <div className="header-res-social mt-[30px]">
                                    <div className="header-top-social">
                                        <ul className="flex flex-row justify-center">
                                            <li
                                                className="list-inline-item h-[30px] w-[30px] flex items-center justify-center bg-[#4b5966] rounded-[5px] mr-[15px]">
                                                <a href="#"><i className="gicon gi-facebook text-[#fff]"></i></a>
                                            </li>
                                            <li
                                                className="list-inline-item h-[30px] w-[30px] flex items-center justify-center bg-[#4b5966] rounded-[5px] mr-[15px]">
                                                <a href="#"><i className="gicon gi-twitter text-[#fff]"></i></a>
                                            </li>
                                            <li
                                                className="list-inline-item h-[30px] w-[30px] flex items-center justify-center bg-[#4b5966] rounded-[5px] mr-[15px]">
                                                <a href="#"><i className="gicon gi-instagram text-[#fff]"></i></a>
                                            </li>
                                            <li
                                                className="list-inline-item h-[30px] w-[30px] flex items-center justify-center bg-[#4b5966] rounded-[5px]">
                                                <a href="#"><i className="gicon gi-linkedin text-[#fff]"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!-- Social End --> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- Mobile Menu sidebar End --> */}
                </header>

                {/* </CartProvider> */}
            </div>

            <div className="h-16 md:h-24"></div>
        </div>
    )
}

export default Header